import { Component, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ExamScheduleService } from 'src/app/services/exam-schedule.service';
import { TranslationService } from 'src/app/services/translation.service';
import { forkJoin } from 'rxjs';
import html2canvas from 'html2canvas';
import { SummaryService } from 'src/app/services/summary.service';

@Component({
  selector: 'app-exam-schedule',
  imports: [CommonModule, FormsModule],
  standalone: true,
  templateUrl: './exam-schedule.component.html',
  styleUrls: ['./exam-schedule.component.css']
})
export class ExamScheduleComponent {

  @ViewChild('printSection') printSection!: ElementRef;

  selectedCandidateID: string = '';
  candidateForToday: any[] = [];
  identification: string = '';
  traineeInfo: any = {};
  examAttendanceNumber: string = '';
  isGenerating: boolean = true;
  isInquiry: boolean = true;
  isSendSMS: boolean = false;

  traineeExamStatus: string = '';
  TestTakeCount: number = 0;

  errorMessage: string = '';
  showAlert: boolean = false;
  successMessage: boolean = false;

  currentDate = new Date();
  currentUser: string = '';
  userBranchId: number = 0;

  constructor(private examScheduleService: ExamScheduleService, public translationService: TranslationService, private summaryService: SummaryService) {}

  ngOnInit() {
    const keys = Object.keys(sessionStorage);
    keys.forEach((key) => {
      const value = sessionStorage.getItem(key);
      if (value !== null) {
        try {
          const parsedValue = JSON.parse(value);
            if (parsedValue && parsedValue.authorityType === "MSSTS") {
              this.currentUser = parsedValue.name
              this.summaryService.getUserBranchId().subscribe((response) => {
                this.userBranchId = response.branchId;
                this.getTodayAssessments();
            });
          }
          } catch (e) {
          }
      }
    });  
  }

  getTodayAssessments() {
    this.summaryService.getTodayAssessments(this.userBranchId).subscribe(
      (response: any) => {
        this.candidateForToday = response.flatMap((item: any) => item.students);
      }
    );
  }

  getSelectedCandidateID() {
    if (this.selectedCandidateID) {
      this.identification = this.selectedCandidateID;
      this.getTraineeDetails();
    }
  }

  getTraineeDetails() {

    forkJoin({
      traineeDetailsByID: this.examScheduleService.getTraineeDetailsByID(this.identification),
      traineeDetails: this.examScheduleService.getTraineeDetails(this.identification),
      traineeResult: this.examScheduleService.getTraineeResult(this.identification),
    }).subscribe(({ traineeDetailsByID, traineeDetails, traineeResult }) => { 

      if (traineeDetails?.studentnid) {

        this.isInquiry = false;
        this.isSendSMS = true;

        const allBookings = traineeDetails?.bookings?.sort((a: any, b: any) => new Date(a.bookingDate).getTime() - new Date(b.bookingDate).getTime()) || [];
        const examResults = traineeResult?.result[0] || [];
        const detailsList = traineeDetailsByID?.result[0] || [];

        const sortedBookings = allBookings;

        let finalStatus = 'No valid attempts';
        let finalExamAttendanceNumber = null;
        let attemptNumber = 1;
        let finalSelectedBooking: any = null;

        for (let i = 0; i < sortedBookings.length; i++) {
          const booking = sortedBookings[i];
          const bookingId = booking?.bookingId;

          const trainingRecord = detailsList.find((item: any) => item?.BookingID === bookingId);

          if (!trainingRecord) {
            finalStatus = 'Ready for ' + booking.bookingType;
            finalExamAttendanceNumber = null;
            attemptNumber = i + 1;
            finalSelectedBooking = booking;
            break;
          }

          const examAttendanceNo = trainingRecord.ExamAttendanceNumber;
          const examRecord = examResults.find((exam: any) => exam?.ExamAttendanceNo === examAttendanceNo);

          if (examRecord) {
            if (examRecord.ExamResult === 'Passed') {
              finalStatus = 'Passed';
              finalExamAttendanceNumber = examAttendanceNo;
              attemptNumber = i + 1;
              finalSelectedBooking = booking;
              break;
            } else if (examRecord.ExamResult === 'In Progress') {
              finalStatus = 'In Progress';
              finalExamAttendanceNumber = examAttendanceNo;
              attemptNumber = i + 1;
              finalSelectedBooking = booking;
              break;
            }
          } else {
            finalStatus = 'In Progress';
            finalExamAttendanceNumber = examAttendanceNo;
            attemptNumber = i + 1;
            finalSelectedBooking = booking;
            break;
          }
        }

        if (!finalSelectedBooking && sortedBookings.length > 0) {
          const lastBooking = sortedBookings[sortedBookings.length - 1];
          const bookingId = lastBooking?.bookingId;

          const trainingRecord = detailsList.find((item: any) => item?.BookingID === bookingId);
          const examAttendanceNo = trainingRecord?.ExamAttendanceNumber;
          const examRecord = examResults.find((exam: any) => exam?.ExamAttendanceNo === examAttendanceNo);

          finalStatus = examRecord?.ExamResult || 'No valid attempts';
          finalExamAttendanceNumber = examAttendanceNo;
          attemptNumber = sortedBookings.length;
          finalSelectedBooking = lastBooking;
        }

        this.traineeExamStatus = finalStatus;
        this.examAttendanceNumber = finalExamAttendanceNumber;
        this.TestTakeCount = attemptNumber;

        this.traineeInfo = {
          traineeID: traineeDetails.studentnid,
          traineeName: traineeDetails.fullname,
          phone: traineeDetails.phone,
          gender: traineeDetails.gender,
          bookingId: finalSelectedBooking?.bookingId,
          bookingDate: finalSelectedBooking?.bookingDate,
          bookingType: finalSelectedBooking?.bookingType,
          scheduleId: finalSelectedBooking?.scheduleId,
          sessionDate: finalSelectedBooking?.sessionDate,
          courseId: finalSelectedBooking?.courseId,
          courseName: traineeDetails.studentclassification,
          branchId: finalSelectedBooking?.branchId,
          courseLang: finalSelectedBooking?.language,
          paymentId: finalSelectedBooking?.paymentId,
          paidAmount: finalSelectedBooking?.paidAmount,
          paymentDate: finalSelectedBooking?.paymentDate,
          branchName: finalSelectedBooking?.branchName,
          cityName: finalSelectedBooking?.cityName,
          traineeExamStatus: this.traineeExamStatus,
        };
  
      } else {
        this.showErrorMessage(this.translationService.getTranslation('No trainee found'));
      }
    });
  }
  
  generateAttendanceNumber() {
    this.traineeInfo.traineeExamStatus = this.traineeExamStatus;

    const generateUnique12DigitCode = async (username: string): Promise<string> => {
      const currentDate = new Date().toISOString();
      const randomValue = crypto.getRandomValues(new Uint32Array(1))[0].toString(36);
      const data = `${currentDate}-${username}-${randomValue}`;

      const hashBuffer = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(data));
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

      const hashBase36 = BigInt(`0x${hashHex}`).toString(36).toUpperCase();

      let finalCode = hashBase36.padStart(12, 'X').substring(0, 12);

      finalCode = hashBase36.replace(/[1iIlLoO0]/gi, '').padStart(12, 'X').substring(0, 12);
      finalCode = 'T' + this.TestTakeCount + '-' + finalCode.match(/.{1,4}/g)?.join('-')?.toUpperCase() || '';

      return finalCode;
    };

    generateUnique12DigitCode(this.traineeInfo.traineeName).then(uniqueCode => {
      this.traineeInfo.examAttendanceNumber = uniqueCode; 

      this.examScheduleService.saveTraineeDetails(this.traineeInfo).subscribe(response => {
        if (response.success = 'true') {
          this.showSuccessMessage(this.translationService.getTranslation('Exam Attendance Number generated successfully')); 
          this.isGenerating = false;
          this.sendSMS();
          this.printExamNumber();
        }
      });
    });
  }



  printExamNumber() {
    const printContents = this.printSection.nativeElement.innerHTML;
    const popupWindow = window.open('', '_blank', 'width=800,height=600');
    
    popupWindow?.document.open();
    popupWindow?.document.write(`
      <html>
        <head>
          <title>Print</title>
          <style>
            body { font-family: "Tajawal", sans-serif !important; padding: 20px; margin-top: 100px;}
            table { width: 100%; border-collapse: collapse; margin-top: 35px; text-align: center;}
            th, td { border: 1px solid #000; padding: 8px; text-align: left; text-align: center;}
          </style>
        </head>
        <body onload="window.print(); window.close();">
          ${printContents}
        </body>
      </html>
    `);
    popupWindow?.document.close();
  }
  

  sendSMS() {
    this.examScheduleService.sendExamAttendanceNumber({ id: this.traineeInfo.traineeID, attendanceNumber: this.traineeInfo.examAttendanceNumber || this.examAttendanceNumber }).subscribe(response => {
      this.isSendSMS = false;
    });
  }

  showErrorMessage(message: string) {
    this.errorMessage = message;
    this.showAlert = true;
    this.traineeInfo = {};
    this.identification = '';
    this.examAttendanceNumber = '';
    this.traineeInfo.examAttendanceNumber = '';
    this.traineeExamStatus = '';
    this.isInquiry = true;
    this.TestTakeCount = 0;
    setTimeout(() => {
      this.showAlert = false;
    }, 2500);
  }

  showSuccessMessage(message: string) {
    this.errorMessage = message;
    this.successMessage = true;
    setTimeout(() => {
      this.successMessage = false;
    }, 5000);
  }
}

